import { render } from "./UsageArchive.vue?vue&type=template&id=91a68e76&scoped=true"
import script from "./UsageArchive.vue?vue&type=script&lang=js"
export * from "./UsageArchive.vue?vue&type=script&lang=js"

import "./UsageArchive.vue?vue&type=style&index=0&id=91a68e76&lang=scss&scoped=true"

import exportComponent from "d:\\Beks\\EasyTicket\\easyticket.webshop.admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91a68e76"]])

export default __exports__